/**
 * Réglages propres à une colonne d'un Bloc, rangés par id de colonne dans
 * `columnStyles` : fond, marge intérieure, et largeur ajustée au contenu.
 *
 * Par id plutôt que dans `sectionColumns` : le champ de disposition réécrit
 * `sectionColumns` à chaque changement de colonnes, et y glisser l'apparence
 * l'aurait exposée à chaque recalcul de grille.
 */

const EMPTY = {};

export function columnStyleOf(columnStyles, id) {
  return columnStyles?.[id] || EMPTY;
}

/** Réglage vidé = clé retirée : une colonne sans réglage ne laisse rien. */
export function withColumnStyle(columnStyles, id, patch) {
  const style = Object.fromEntries(
    Object.entries({ ...columnStyleOf(columnStyles, id), ...patch })
      .filter(([, value]) => value !== '' && value != null && value !== false),
  );
  const { [id]: _previous, ...others } = columnStyles || {};
  return Object.keys(style).length ? { ...others, [id]: style } : others;
}

/**
 * Props de la `Grid.Col` d'une colonne. Ajustée au contenu, elle prend la
 * largeur de sa box à toutes les tailles d'écran : des boutons côte à côte
 * gardent un écart constant, quelle que soit la longueur de leur libellé, et
 * passent à la ligne quand la place manque.
 */
export function columnColProps(columnStyles, id, span) {
  const style = columnStyleOf(columnStyles, id);
  return {
    span: style.fit ? 'content' : span,
    style: {
      backgroundColor: style.backgroundColor || undefined,
      padding: style.padding || undefined,
    },
  };
}
